import { reactive } from 'vue'
import { required, helpers, minLength, maxLength } from '@vuelidate/validators'
import GeneralRules from './GeneralRules';

class InfoPepAccionista_JuridicoValidacion{

     public ObtenerReglasValidacion() {

         const objetoInfoPepAccionista_Juridico = reactive({
             PepAJ:[{
                NombreAJ_PEP: '',
                NombrePEP: '',
                TipoIdPEPAJ: '',
                NumeroIdentificacionPEPAJ: '',
                TipoVinculoPEPAJ: '',
                TipoPEPAJ: ''
             }]
         });

         const requiredMessage = 'Campo obligatorio';

         const patternRule = (pattern: RegExp) => ({
            $validator: (value: string) => pattern.test(value),
            trigger: ['blur', 'change'],
            });

        const validarNumeroPorTipoId = helpers.withMessage
            ('No se admiten espacios ni caracteres especiales', 
                (value: string, {TipoIdPEPAJ}:{TipoIdPEPAJ:string}) => {
                    if(!value || !TipoIdPEPAJ) return false;
                        return GeneralRules.ValidateRegex(value,TipoIdPEPAJ);      
            });
            
        const validarTamanoNumero = helpers.withMessage
            ('El rango de caracteres no es admitido', 
                (value: string, {TipoIdPEPAJ}:{TipoIdPEPAJ:string}) => {
                    if(!value || !TipoIdPEPAJ) return false;
                        return GeneralRules.ValidateSize(value,TipoIdPEPAJ);      
            });
   
        const reglaCaracteresEspeciales = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+( [a-zA-ZáéíóúÁÉÍÓÚñÑ]+)*$/;
         
         const reglasValidacion = {
            PepAJ: {
                 $each: helpers.forEach({
                    NombreAJ_PEP: {
                         required: helpers.withMessage(requiredMessage, required),
                         minLength: helpers.withMessage('El rango de caracteres admitidos en este campo es de 2 a 100',minLength(2)),  
                         maxLength: helpers.withMessage('El rango de caracteres admitidos en este campo es de 2 a 100',maxLength(100)),         
                         patternRuleCarecteres: helpers.withMessage('No se admiten espacios al inicio o al final ni caracteres especiales', patternRule(reglaCaracteresEspeciales))
                     },
                     NombrePEP: {
                         required: helpers.withMessage(requiredMessage, required),
                         minLength: helpers.withMessage('El rango de caracteres admitidos en este campo es de 2 a 100',minLength(2)),  
                         maxLength: helpers.withMessage('El rango de caracteres admitidos en este campo es de 2 a 100',maxLength(100)),         
                         patternRuleCarecteres: helpers.withMessage('No se admiten espacios al inicio o al final ni caracteres especiales', patternRule(reglaCaracteresEspeciales))
                     },
                     TipoIdPEPAJ: {
                         required: helpers.withMessage(requiredMessage, required),
                     },
                     NumeroIdentificacionPEPAJ: {
                         required: helpers.withMessage(requiredMessage, required),
                         validarNumeroPorTipoId,
                         validarTamanoNumero
                     },
                     TipoVinculoPEPAJ: {
                         required: helpers.withMessage(requiredMessage, required),
                         maxLength: helpers.withMessage('El rango de caracteres en este campo es de 1 a 10',maxLength(10)),
                         patternRuleCarecteres: helpers.withMessage('No se admiten espacios ni caracteres especiales', patternRule(reglaCaracteresEspeciales))
                     },
                     TipoPEPAJ: {
                        required: helpers.withMessage(requiredMessage, required),
                    }
                 })
             }       
         };

        return [objetoInfoPepAccionista_Juridico, reglasValidacion] as const;
    }
}

export default InfoPepAccionista_JuridicoValidacion;